import { useCallback, useMemo } from "react"
import { useDeleteConfirm } from "../../../../hooks/useDeleteConfirm"
import { useDeviceFamilies } from "../../../../hooks/useDeviceFamilies"
import { DimaFeatureShortNameEnum } from "../../../models/Authorization"
import { DeviceFamilyGet } from "../../../models/DeviceFamily"
import { deleteEntity } from "../../../utils/deleteEntity"
import { DiMaAddButton } from "../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../partials/EntityTab"

export function Families() {
  const { deviceFamiliesList, isLoadingDeviceFamilies } = useDeviceFamilies()
  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()

  const columns = [
    {
      field: "name",
      headerName: "Name",
      isLink: true,
      linkBasePath: "/devices/families",
    },
    { field: "description", headerName: "Description" },
  ]

  const sorted = [...deviceFamiliesList].sort((a, b) =>
    (a.name ?? "").localeCompare(b.name ?? "")
  )

  const rows = sorted.map((deviceFamily: DeviceFamilyGet) => ({
    id: deviceFamily.id,
    name: deviceFamily.name,
    description: deviceFamily.description,
  }))

  const toolbar = useMemo(
    () => (
      <DiMaAddButton
        url="/devices/families/create"
        feature={DimaFeatureShortNameEnum.DM}
      />
    ),
    []
  )

  const handleActionMenuClick = useCallback(
    (item: { title: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        requestDelete(() => deleteEntity(`/deviceFamilies/${row.id}`))
      }
    },
    [requestDelete]
  )

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
        rows={rows}
        cols={columns}
        isLoading={isLoadingDeviceFamilies}
        toolbar={toolbar}
        actionItems={[{ title: "Delete", iconName: "icon_abb_dias icon-abb_delete" }]}
        onActionMenuClick={handleActionMenuClick}
      />
    </>
  )
}
